module.exports = __webpack_public_path__ + "static/media/linked-in-share_button.46248684.svg";